module.exports = __webpack_public_path__ + "img/coins.d3099cbd.png";